module.exports = __webpack_public_path__ + "static/media/icn-upload-avatar.e2f02bd1.svg";